/** Formats a token count into a compact human-readable string (e.g. 1.2k). */
export function compactUsage(value: number): string {
  if (value < 1_000) return String(value);
  const compact = value / 1_000;
  return `${Number.isInteger(compact) ? compact : compact.toFixed(1)}k`;
}
